import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { getCustomers, getCustomerById, updateCustomer, deleteCustomer, setActivePage, showLoading, hideLoading, openCustomerModal, retrieveCreditRecords, topupCredit, createCustomerAccount } from '../actions';
import { Modal, Form, Button, Icon, Input, Table, Checkbox, Segment } from 'semantic-ui-react';

const defaultCustomer = {
    name: '',
    email: '',
    mobile: '',
    phone: '',
    company: '',
    address: {
        address_1: '',
        address_2: '',
        postcode: '',
        town_city: '',
        state: '',
        country: 'MALAYSIA'
    },
    balance: {
        value: 0.0
    },
    meter_click: { enable: false, printing: [] },
}

const stateOpt = [
    { key: 'JOHOR', text: 'JOHOR', value: 'JOHOR' },
    { key: 'KEDAH', text: 'KEDAH', value: 'KEDAH' },
    { key: 'KELANTAN', text: 'KELANTAN', value: 'KELANTAN' },
    { key: 'MELAKA', text: 'MELAKA', value: 'MELAKA' },
    { key: 'NEGERI SEMBILAN', text: 'NEGERI SEMBILAN', value: 'NEGERI SEMBILAN' },
    { key: 'PAHANG', text: 'PAHANG', value: 'PAHANG' },
    { key: 'PULAU PINANG', text: 'PULAU PINANG', value: 'PULAU PINANG' },
    { key: 'PERAK', text: 'PERAK', value: 'PERAK' },
    { key: 'PERLIS', text: 'PERLIS', value: 'PERLIS' },
    { key: 'SELANGOR', text: 'SELANGOR', value: 'SELANGOR' },
    { key: 'TERENGGANU', text: 'TERENGGANU', value: 'TERENGGANU' },
    { key: 'WILAYAH PERSEKUTUAN', text: 'WILAYAH PERSEKUTUAN', value: 'WILAYAH PERSEKUTUAN' },
    { key: 'SABAH', text: 'SABAH', value: 'SABAH' },
    { key: 'SARAWAK', text: 'SARAWAK', value: 'SARAWAK' },
]

const country = [
    { key: 'MALAYSIA', text: 'MALAYSIA', value: 'MALAYSIA' },
]

class CustomerDetails extends Component {
    state = {
        customerModalOpen: false,
        selectedCustomer: defaultCustomer,
        editable: false,
        deleteModal: false,
        creditModal: false,
        confirmTopupModal: false,
        topupAmount: 0,
        countryopt: 'MALAYSIA'
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.customer.selectedCustomer !== nextProps.customer.selectedCustomer) {
            console.log(nextProps.customer.selectedCustomer)
            console.log(defaultCustomer);
            this.setState({
                selectedCustomer: { ...defaultCustomer, ...nextProps.customer.selectedCustomer },
                customerModalOpen: nextProps.customer.customerModalOpen,
                deleteModal: (nextProps.customer.customerModalOpen) ? this.state.deleteModal : nextProps.customer.customerModalOpen,
                editable: (nextProps.customer.selectedCustomer) ? false : true,
                confirmTopupModal: false,
                topupAmount: 0
            });

            if (nextProps.customer.selectedCustomer.meter_click) {
                const { meter_click } = nextProps.customer.selectedCustomer;

                this.setState({
                    meter_click_enable: meter_click.enable,
                    paper_4col: meter_click.printing.find((el) => ((el.material.toUpperCase() === 'PAPER') && (el.type.toUpperCase() === '4 COLOUR'))).unit_price,
                    paper_1col: meter_click.printing.find((el) => ((el.material.toUpperCase() === 'PAPER') && (el.type.toUpperCase() === '1 COLOUR'))).unit_price,
                    card_4col: meter_click.printing.find((el) => ((el.material.toUpperCase() === 'CARD') && (el.type.toUpperCase() === '4 COLOUR'))).unit_price,
                    card_1col: meter_click.printing.find((el) => ((el.material.toUpperCase() === 'CARD') && (el.type.toUpperCase() === '1 COLOUR'))).unit_price
                });
            } else {
                this.setState({
                    meter_click_enable: false,
                    paper_4col: "",
                    paper_1col: "",
                    card_4col: "",
                    card_1col: ""
                });
            }
        }


        if (this.props.customer.creditRecords !== nextProps.customer.creditRecords) {
            if (nextProps.customer.creditRecords) {
                console.log(nextProps.customer.creditRecords);
                this.setState({ creditModal: true, confirmTopupModal: false, topupAmount: 0 });
            } else {
                this.setState({ creditModal: false, confirmTopupModal: false, topupAmount: 0 });
            }
        }
    }


    handleInput(e) {
        let newCustomerInfo = { ...this.state.selectedCustomer }

        if (e.target.name !== 'email') {
            newCustomerInfo[e.target.name] = e.target.value.toUpperCase();
        } else {
            newCustomerInfo[e.target.name] = e.target.value;
        }

        this.setState({
            selectedCustomer: {
                ...newCustomerInfo
            }
        });
    }

    handleMeterClickInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleAddressInput(e, { value }) {

        let newAddress = this.state.selectedCustomer.address;
        console.log(e.target.name);
        newAddress[e.target.name] = e.target.value.toUpperCase();


        this.setState({
            selectedCustomer: {
                ...this.state.selectedCustomer,
                address: newAddress
            }
        });
    }

    handleStateSelect(e, { value }) {
        let newCustomer = { ...this.state.selectedCustomer };
        newCustomer.address.state = value;
        console.log(value);
        this.setState({
            selectedCustomer: newCustomer
        });
    }

    handleCountrySelect(e, { value }) {
        let newCustomer = { ...this.state.selectedCustomer };
        newCustomer.address.country = value;
        console.log(value);
        this.setState({
            selectedCustomer: newCustomer
        });
    }

    handleCloseCustomerModal = () => {
        this.props.openCustomerModal(false);
    }

    handleEditCustomer = () => {
        this.setState({ editable: !this.state.editable });
    }

    handleSaveProfile = () => {
        let selectedCustomer = { ...this.state.selectedCustomer }

        console.log(this.state);

        if (this.state.paper_4col && this.state.paper_1col && this.state.card_4col && this.state.card_1col) {
            selectedCustomer.meter_click = {
                enable: this.state.meter_click_enable,
                printing: [
                    { type: '4 Colour', material: 'Paper', unit_price: parseFloat(this.state.paper_4col) },
                    { type: '1 Colour', material: 'Paper', unit_price: parseFloat(this.state.paper_1col) },
                    { type: '4 Colour', material: 'Card', unit_price: parseFloat(this.state.card_4col) },
                    { type: '1 Colour', material: 'Card', unit_price: parseFloat(this.state.card_1col) }
                ]
            }
        } else {
            selectedCustomer.meter_click = undefined;
        }
        selectedCustomer.balance = undefined;
        console.log(selectedCustomer)
        if (selectedCustomer._id) {
            this.props.updateCustomer(selectedCustomer);
        }
        else {
            console.log('ADDED CUSTOMER')
            this.props.createCustomerAccount({ selectedCustomer });
            this.props.openCustomerModal(false);
        }
        this.setState({ editable: false });
    }

    handleDelete = (state) => {
        console.log('Delete ' + state);
        this.setState({ deleteModal: state });
    }

    confirmDelete = () => {
        this.props.deleteCustomer({ _id: this.state.selectedCustomer._id });
    }

    handleCredit = () => {
        this.props.retrieveCreditRecords(this.state.selectedCustomer.email);
    }

    handleTopup = () => {
        this.setState({ confirmTopupModal: true });
    }

    confirmTopup = () => {
        this.props.topupCredit(this.state.selectedCustomer.email, this.props.user.email, this.state.topupAmount);
    }

    handleMeterClickEnable(e) {
        this.setState({ meter_click_enable: !this.state.meter_click_enable });
    }

    render() {
        const { selectedCustomer, customerModalOpen, editable, deleteModal, creditModal, confirmTopupModal, topupAmount, meter_click_enable, paper_4col, paper_1col, card_4col, card_1col } = this.state;
        const { creditRecords } = this.props.customer;
        let addCustomer = customerModalOpen & !selectedCustomer._id;

        return (
            selectedCustomer
                ? (
                    <Fragment>
                        <Modal
                            dimmer={true}
                            style={styles.modal}
                            open={deleteModal}
                            onOpen={this.handleDelete.bind(this, true)}
                            onClose={this.handleDelete.bind(this, false)}
                            size='small'
                        >
                            <Modal.Header>Confirm Delete</Modal.Header>
                            <Modal.Content>
                                <p>Are you sure you want to delete this customer?</p>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={this.handleDelete.bind(this, false)}>Cancel</Button>
                                <Button positive icon='check' content='OK' onClick={this.confirmDelete.bind(this, false)} />
                            </Modal.Actions>
                        </Modal>
                        <Modal
                            dimmer={true}
                            style={styles.modal}
                            open={creditModal}
                        >
                            <Modal.Header>Credit Activities</Modal.Header>
                            <Modal.Content scrolling>
                                <Table striped>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Date</Table.HeaderCell>
                                            <Table.HeaderCell>Action</Table.HeaderCell>
                                            <Table.HeaderCell>Handler</Table.HeaderCell>
                                            <Table.HeaderCell>Amount</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {
                                            (creditRecords &&
                                                creditRecords.map((record) => (
                                                    <Table.Row>
                                                        <Table.Cell>{moment(record.date).format('DD-MM-YYYY')}</Table.Cell>
                                                        <Table.Cell>{record.action}</Table.Cell>
                                                        <Table.Cell>{record.staff}</Table.Cell>
                                                        <Table.Cell>{record.amount.toFixed(2)}</Table.Cell>
                                                    </Table.Row>
                                                ))
                                            )
                                        }
                                    </Table.Body>
                                </Table>
                            </Modal.Content>
                            <Modal.Actions>
                                <Input type='number' name='topup'
                                    action={{ color: 'teal', labelPosition: 'right', icon: 'add circle', content: 'Top Up', onClick: this.handleTopup.bind(this) }}
                                    placeholder='Amount' onChange={(e) => this.setState({ topupAmount: Number(e.target.value) })} />
                                <Button positive content='Close' onClick={() => this.setState({ topupAmount: 0, creditModal: false })} />
                            </Modal.Actions>
                        </Modal>
                        <Modal
                            dimmer={true}
                            style={styles.modal}
                            open={confirmTopupModal}
                            size='small'
                        >
                            <Modal.Header>Confirm Top Up</Modal.Header>
                            <Modal.Content>
                                <p>Top up RM {topupAmount.toFixed(2)} to {selectedCustomer.email} confirm?</p>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={() => this.setState({ topupAmount: 0, confirmTopupModal: false })}>Cancel</Button>
                                <Button positive icon='check' content='OK' onClick={this.confirmTopup.bind(this)} />
                            </Modal.Actions>
                        </Modal>
                        <Modal open={customerModalOpen} style={styles.modal} onClose={this.handleCloseCustomerModal.bind(this)}>
                            <Modal.Header>
                                {(selectedCustomer._id) ? 'Customer Info' : 'Add Customer'}
                                {(selectedCustomer._id) &&
                                    <div style={{ float: 'right' }}>
                                        <Icon name='money' style={styles.modal_icon} onClick={this.handleCredit.bind(this, true)} />
                                        <Icon name='edit' style={styles.modal_icon} onClick={this.handleEditCustomer.bind(this)} />
                                        <Icon name='trash' style={styles.modal_icon} onClick={this.handleDelete.bind(this, true)} />
                                    </div>
                                }
                            </Modal.Header>
                            <Modal.Content>
                                <Form>
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-customer-name' name='name' label='Name' control={Input} type='text' value={selectedCustomer.name} onChange={this.handleInput.bind(this)} readOnly={selectedCustomer._id} />
                                        <Form.Field id='form-customer-id' name='_id' label='ID' control={Input} type='text' value={selectedCustomer._id} onChange={this.handleInput.bind(this)} disabled={addCustomer} readOnly={true} />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-customer-mobile' name='mobile' label='Mobile' control={Input} type='tel' value={selectedCustomer.mobile} onChange={this.handleInput.bind(this)} readOnly={!editable && !addCustomer} />
                                        <Form.Field id='form-customer-phone' name='phone' label='Phone' control={Input} type='tel' value={selectedCustomer.phone} onChange={this.handleInput.bind(this)} readOnly={!editable && !addCustomer} />
                                    </Form.Group>
                                    <Form.Field id='form-customer-email' name='email' label='Email' control={Input} type='email' value={selectedCustomer.email} onChange={this.handleInput.bind(this)} readOnly={selectedCustomer._id} />
                                    <Form.Field id='form-customer-company' name='company' label='Company' control={Input} value={selectedCustomer.company} onChange={this.handleInput.bind(this)} readOnly={!editable && !addCustomer} />
                                    <Form.Field id='form-customer-address-street-1' name='address_1' control={Input} label='Address' placeholder='Address Line 1' value={selectedCustomer.address.address_1} onChange={this.handleAddressInput.bind(this)} readOnly={!editable && !addCustomer} />
                                    <Form.Field id='form-customer-address-street-2' name='address_2' control={Input} placeholder='Address Line 2' value={selectedCustomer.address.address_2} onChange={this.handleAddressInput.bind(this)} readOnly={!editable && !addCustomer} />
                                    <Form.Group widths='equal'>
                                        <Form.Field id='form-customer-address-postcode' name='postcode' control={Input} placeholder='Post Code' value={selectedCustomer.address.postcode} onChange={this.handleAddressInput.bind(this)} readOnly={!editable && !addCustomer} />
                                        <Form.Field id='form-customer-address-town_city' name='town_city' control={Input} placeholder='City' value={selectedCustomer.address.town_city} onChange={this.handleAddressInput.bind(this)} readOnly={!editable && !addCustomer} />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Select id='form-customer-address-state' name='state' placeholder='State' value={selectedCustomer.address.state} onChange={this.handleStateSelect.bind(this)} disabled={!editable && !addCustomer}
                                            options={stateOpt} />
                                        <Form.Select id='form-customer-address-country' name='country' options={country} placeholder='Country' value={selectedCustomer.address.country} onChange={this.handleCountrySelect.bind(this)} disabled={!editable && !addCustomer} />
                                    </Form.Group>
                                    <Form.Field id='form-customer-balance' name='balance' label='Balance (RM)' control={Input} value={selectedCustomer.balance.value.toFixed(2)}  readOnly={true} />
                                    <Form.Field label='Meter Click'></Form.Field>
                                    <Segment>
                                        <Form.Field> <Checkbox toggle name='meter_click_enable' label='Enable' readOnly={!editable && !addCustomer} onChange={this.handleMeterClickEnable.bind(this)} checked={meter_click_enable} /></Form.Field>
                                        <Form.Group widths='equal'>
                                            <Form.Field id='form-customer-meter_click-paper-4C' name='paper_4col' label='4 Colour (Paper)' type='number' min='0' step='0.01' control={Input} placeholder='4 Colour (Paper)' onChange={this.handleMeterClickInput.bind(this)} value={paper_4col} readOnly={!editable && !addCustomer} />
                                            <Form.Field id='form-customer-meter_click-paper-1C' name='paper_1col' label='1 Colour (Paper)' type='number' min='0' step='0.01' control={Input} placeholder='1 Colour (Paper)' onChange={this.handleMeterClickInput.bind(this)} value={paper_1col} readOnly={!editable && !addCustomer} />
                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.Field id='form-customer-meter_click-card-4C' name='card_4col' label='4 Colour (Card)' type='number' min='0' step='0.01' control={Input} placeholder='4 Colour (Card)' onChange={this.handleMeterClickInput.bind(this)} value={card_4col} readOnly={!editable && !addCustomer} />
                                            <Form.Field id='form-customer-meter_click-card-1C' name='card_1col' label='1 Colour (Card)' type='number' min='0' step='0.01' control={Input} placeholder='1 Colour (Card)' onChange={this.handleMeterClickInput.bind(this)} value={card_1col} readOnly={!editable && !addCustomer} />
                                        </Form.Group>
                                    </Segment>
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button onClick={this.handleCloseCustomerModal.bind(this)}>Cancel</Button>
                                <Button positive icon='save' disabled={!editable && !addCustomer} content='Save' onClick={this.handleSaveProfile.bind(this)} />
                            </Modal.Actions>
                        </Modal>
                    </Fragment>)
                : null
        )
    }
}

const styles = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    modal_icon: {
        color: '#1e70bf',
        width: '2em',
        cursor: 'pointer'
    }
};

const mapStateToProps = ({ auth, customer }) => {
    return {
        customer,
        user: {
            _id: auth.user._id,
            name: auth.user.name,
            email: auth.user.email
        }
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateCustomer: updateCustomer,
        deleteCustomer: deleteCustomer,
        getCustomers: getCustomers,
        getCustomerById: getCustomerById,
        setActivePage: setActivePage,
        showLoading: showLoading,
        hideLoading: hideLoading,
        openCustomerModal: openCustomerModal,
        retrieveCreditRecords: retrieveCreditRecords,
        topupCredit: topupCredit,
        createCustomerAccount: createCustomerAccount
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(CustomerDetails);